// Chat REST bindings. Mirrors iOS ChatEndpoints + /chat/*. Live updates come
// over the WebSocket in chat-socket.ts.
import { api } from "./client";
import type { ChatRoomSummary, MessageRead, ReactionSummary } from "./community-types";

export function listChatRooms(): Promise<ChatRoomSummary[]> {
  return api.get<ChatRoomSummary[]>("/chat/rooms");
}

export function openDM(userId: string): Promise<ChatRoomSummary> {
  return api.post<ChatRoomSummary>("/chat/dm", { user_id: userId });
}

/** History is returned newest-first; callers reverse for display. */
export function getMessages(roomId: string, limit = 50): Promise<MessageRead[]> {
  return api.get<MessageRead[]>(`/chat/rooms/${encodeURIComponent(roomId)}/messages`, {
    query: { limit },
  });
}

export function sendMessage(roomId: string, body: string): Promise<MessageRead> {
  return api.post<MessageRead>(`/chat/rooms/${encodeURIComponent(roomId)}/messages`, { body });
}

/** Toggle the caller's emoji reaction. Returns the message's updated reactions. */
export function toggleReaction(
  roomId: string,
  messageId: string,
  emoji: string,
): Promise<ReactionSummary[]> {
  return api.post<ReactionSummary[]>(
    `/chat/rooms/${encodeURIComponent(roomId)}/messages/${encodeURIComponent(messageId)}/reactions`,
    { emoji },
  );
}
